import ModalTitle from '@components/common/modal/ModalTitle';
import CloseModalButton from '@components/common/modal/CloseModalButton';

type ModalHeaderPropsType = {
  title?: string | React.ReactElement;
  dark?: boolean;
  onClose: Function;
  onClickClose?: Function;
  titlePosition?: 'center' | 'default';
};

const ModalHeader = ({
  title,
  dark,
  onClose,
  onClickClose,
  titlePosition,
}: ModalHeaderPropsType): React.ReactElement => {
  const handleClickClose = () => {
    onClickClose && onClickClose();
    onClose();
  };

  return (
    <div className="relative">
      <ModalTitle titlePosition={titlePosition}>{title}</ModalTitle>
      <div className="absolute right-0 top-0">
        <CloseModalButton dark={dark} onClose={handleClickClose} />
      </div>
    </div>
  );
};

export default ModalHeader;
